var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { transferOptions } from '@src/app/helper';
import { Fragment } from 'react';
var TransferActionDropdown = function (_a) {
    var record = _a.record, handleProcess = _a.handleProcess, transferType = _a.transferType;
    return (_jsx(Fragment, { children: _jsx("div", __assign({ className: 'text-center' }, { children: transferType === transferOptions.pertermin ? (_jsx("button", __assign({ type: 'button', className: 'btn btn-sm btn-primary mx-2', onClick: function () { return handleProcess(record); } }, { children: "Proses" }))) : ('-') })) }));
};
export default TransferActionDropdown;
